import React, { useState, useEffect } from "react";
import Bar from "./Components/Bar";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import CorrBase from "./Components/CorrBase/CorrBase";
import PerfBase from "./Components/PerfBase/PerfBase";
import OutputPage from "./Components/OutputPage/OutputPage";
import Home from "./Components/Home";
import Homev2 from "./Components/Version2/Homev2"
import OutputPagev2 from "./Components/Version2/OutputPagev2"
import VfdCalcApp from "./Components/VfdCalcApp/VfdCalcApp";
import Sidebar from "./Components/Sidebar";
import Exit from "./Components/Exit";
import { Box } from "@mui/system";
import { Container } from "@mui/material";
import { ReactAuthWrapper } from "@carrier-sce-sharedpackages/reactauthwrapper";
import appConfig from "./config";
import { VfdCalcOutput } from "./Components/VfdCalcApp/VfdCalcOutput";

function App() {
  const [corrosionData, setCorrosionData] = React.useState(null);
  const [buidingInfoTable, setBuidingInfoTable] = useState("");
  const [buidingInfoTableHR, setBuidingInfoTableHR] = useState("");
  const [buidingInfoTableWeigh, setBuidingInfoTableWeigh] = useState("");
  const [buidingInfoTableTemp, setBuidingInfoTableTemp] = useState("");
  const [vfdCalcData, setVfdCalcData] = useState(null);

  const [appAccess, setAppAccess] = useState(false);
  const callback = (permissions) => {
    console.log("permissions->", permissions);
    if (permissions.appAccess) {
      console.log("permissions->", permissions.appAccess);
      setAppAccess(true);
    }
  };

  return (
    <ReactAuthWrapper appConfig={appConfig.api} getPermissions={callback}>
      {appAccess && (
        // Application Code (User has access)
        <BrowserRouter>
          <Container maxWidth sx={{ minHeight: "100vh", width: "90%" }}>
            <Box sx={{ display: "flex" ,bgcolor:"#efefef"}}>
              <Bar />
            </Box>
            <Sidebar />
            <Routes>
              <Route
                exact
                path="/"
                element={
                  <Home
                    setCorrosionData={setCorrosionData}
                    corrosionData={corrosionData}
                    setBuidingInfoTable={setBuidingInfoTable}
                    setBuidingInfoTableHR={setBuidingInfoTableHR}
                    setBuidingInfoTableWeigh={setBuidingInfoTableWeigh}
                    setBuidingInfoTableTemp={setBuidingInfoTableTemp}
                  />
                }
              />
              <Route
                exact
                path="/outputs"
                element={
                  <OutputPage
                    corrosionData={corrosionData}
                    buidingInfoTable={buidingInfoTable}
                    buidingInfoTableHR={buidingInfoTableHR}
                    buidingInfoTableWeigh={buidingInfoTableWeigh}
                    buidingInfoTableTemp={buidingInfoTableTemp}
                  />
                }
              />
              <Route
                exact
                path="/version2"
                element={
                  <Homev2
                    setCorrosionData={setCorrosionData}
                    corrosionData={corrosionData}
                    setBuidingInfoTable={setBuidingInfoTable}
                    setBuidingInfoTableHR={setBuidingInfoTableHR}
                    setBuidingInfoTableWeigh={setBuidingInfoTableWeigh}
                    setBuidingInfoTableTemp={setBuidingInfoTableTemp}
                  />
                }
              />
              <Route
                exact
                path="/version2outputs"
                element={
                  <OutputPagev2
                    corrosionData={corrosionData}
                    buidingInfoTable={buidingInfoTable}
                    buidingInfoTableHR={buidingInfoTableHR}
                    buidingInfoTableWeigh={buidingInfoTableWeigh}
                    buidingInfoTableTemp={buidingInfoTableTemp}
                  />
                }
              />
              <Route exact path="/vfd" element={<VfdCalcApp 
              vfdClacData={setVfdCalcData}/>} />
              <Route exact path="/logout" element={<Exit />} />
              <Route exact path="/vfdoutput" element={<VfdCalcOutput vfdData={vfdCalcData}/>} />
            </Routes>
          </Container>
        </BrowserRouter>
      )}
    </ReactAuthWrapper>
  );
}

export default App;
